import React from 'react';
import c from 'classnames';
import s from './Title.scss';
var Title = function (_a) {
    var value = _a.value, isConcise = _a.isConcise, className = _a.className;
    return (React.createElement("div", { className: c(s['title'], isConcise && s['concise'], className) }, value));
};
Title.displayName = 'Title';
export default Title;
//# sourceMappingURL=Title.js.map